import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';
import MapView from './MapView';
import BreadCrumbs from './BreadCrumbs';

import config from './../config';

class HrepparListView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/hreppar/';

		this.state = {
			mapData: []
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id != this.props.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		fetch(this.url+(this.props.match.params.id ? this.props.match.params.id+'/' : ''))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					baeir: json.baeir,
					hreppur: json.hreppur[0],
					sysla: json.sysla[0],
					mapData: json.baeir.map((baer) => {
						if (baer.lat && baer.lng) {
							return {
								id: baer.id,
								label: baer.baejarnafn,
								district: json.hreppur[0].nafn+', '+json.sysla[0].nafn,
								type: 'farm',
								latLng: [baer.lat, baer.lng]
							};
						}
					})
				});
			}.bind(this));
	}

	render() {
		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					{
						this.state.baeir &&
						<div className="column-content">
							<BreadCrumbs path={[
								{
									path: '/syslur/',
									title: 'Sýslur'
								},
								{
									path: '/syslur/'+this.state.sysla.id,
									title: this.state.sysla.nafn
								},
								{
									path: '',
									title: this.state.hreppur.nafn
								}
							]} />
							<div className="row">
								<div className="col col-12 col-md-4">
									<h3>{this.state.hreppur.nafn}</h3>
									<hr/>
									<h5>Bæir</h5>
									<table className="table">
										<thead>
											<tr>
												<th>Nafn</th><th></th>
											</tr>
										</thead>
										<tbody>
											{
												this.state.baeir.map((item, index) => <tr key={index}>
													<td><Link to={'/baer/'+item.id}>{item.baejarnafn}</Link></td>
													<td>{item.fjoldi_skjala > 0 ? (item.fjoldi_skjala === 1 ? item.fjoldi_skjala+' skjal' : item.fjoldi_skjala+' skjöl') : ''}</td>
												</tr>)
											}
										</tbody>
									</table>

								</div>

								<div className={'col col-12 col-md-8'}>
									<MapView mapData={this.state.mapData} />
								</div>

							</div>
						</div>
					}
				</div>

			</div>
		);
	}
}

export default withRouter(HrepparListView);



// WEBPACK FOOTER //
// ./src/components/HrepparListView.js